import { MarketConfiguration } from "@/config/markets/const";
import { Cart } from "@repo/core/cart";
import { getPriceFromVariant } from "@server/requests/elevate/utils";
import { AddCartItemInput } from "../hooks/useAddToCart";
import { createCartItemSkeleton } from "./createCartItemSkeleton";

export default function addToCartOptimistically(
  input: AddCartItemInput,
  marketConfig: MarketConfiguration,
  currentCart?: Cart | null,
): Cart | null {
  if (!currentCart) {
    return null;
  }

  if (!input.length) {
    return currentCart;
  }

  const updatedItems = currentCart.items;

  for (const item of input) {
    const { product, quantity: incomingQuantity } = item;
    const [variant] = product.variants;
    const index = currentCart.items.findIndex(
      (item) => item.partNo === variant?.key,
    );
    const itemExistsInCart = index > -1;
    if (itemExistsInCart && updatedItems[index]) {
      const updatedItem = updatedItems[index];
      const quantity = incomingQuantity + updatedItem.quantity;
      updatedItems[index] = {
        ...updatedItem,
        quantity,
        totalGrossAmount: updatedItem.price * quantity,
      };
    } else {
      const price = getPriceFromVariant(product, marketConfig);
      const imageKey =
        product.typedCustom?.json.v2_variantMainImageKey ??
        product.typedCustom?.json.v2_productMainImageKey;
      updatedItems.push(
        createCartItemSkeleton({
          lineNo: updatedItems.length + 1,
          quantity: item.quantity,
          totalDiscount: 0,
          totalGrossAmount: 0,
          totalVat: 0,
          vatPerItem: 0,
          partNo: variant?.key ?? product.key,
          name: product.name,
          brand: product.brand,
          imageKey: imageKey,
          price: price.price,
        }),
      );
    }
  }

  const newTotal = updatedItems.reduce(
    (sum, item) => sum + item.totalGrossAmount,
    0,
  );

  return {
    ...currentCart,
    items: updatedItems,
    totalGrossAmount: newTotal + currentCart.totalFreightInclVat,
  };
}
